import { render } from "./AssociationOverview.vue?vue&type=template&id=e4968f6c&scoped=true"
import script from "./AssociationOverview.vue?vue&type=script&lang=js"
export * from "./AssociationOverview.vue?vue&type=script&lang=js"

import "./AssociationOverview.vue?vue&type=style&index=0&id=e4968f6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4968f6c"]])

export default __exports__